import React from 'react';
import { toast } from 'react-toastify';
import { getNewNotifications, getNewNotificationsCount } from './actions/eventsApi';
import { setDashboardNeedsRefresh } from './actions/dashboardActions';
import { Auth } from 'aws-amplify';
import { getNavigate } from '../components/navigationHelper';
import {
    getOpenKnotsToastFromNotificationRecord,
    hasRecentOpenKnotsLifecycleToast,
} from '../realtime/openKnotsBidLifecycle';
import { showOpenKnotsLifecycleToast } from '../realtime/openKnotsToast';

const EXCLUDED_ACTION_TYPES = new Set([
    'events/updatePrevPageNotification',
    'events/updateNextPrevPage',
    'getAllPorts/pending',
    'getAllPorts/fulfilled',
]);

export const getNotificationUserUlid = () => {
    const platform_role = localStorage.getItem('platform_role');
    if (platform_role === 'broker') {
        return localStorage.getItem('brokerUlid');
    }
    return localStorage.getItem('loggedUserUlid');
};

export const shouldFetchNotifications = (action, userUlId, notificationInProgress) =>
    Boolean(userUlId) && !notificationInProgress && !EXCLUDED_ACTION_TYPES.has(action.type);

const NEW_NOTIFICATIONS_TOAST_ID = 'new-notifications';
const NEW_NOTIFICATIONS_AUTO_CLOSE_MS = 5000;
let newNotificationsDismissTimer = null;

export const showNewNotificationToast = (payload, selectedBuyer) => {
    if (newNotificationsDismissTimer) {
        clearTimeout(newNotificationsDismissTimer);
        newNotificationsDismissTimer = null;
    }
    toast.info(`${payload} New Notifications`, {
        toastId: NEW_NOTIFICATIONS_TOAST_ID,
        icon: React.createElement('span', { className: 'sf-notification' }),
        onClick: () => {
            const navigate = getNavigate();
            navigate('/notifications', {
                state: { selectedBuyer },
            });
            toast.dismiss(NEW_NOTIFICATIONS_TOAST_ID);
        },
        autoClose: NEW_NOTIFICATIONS_AUTO_CLOSE_MS,
        pauseOnFocusLoss: false,
        style: {
            cursor: 'pointer',
        },
    });
    // react-toastify only starts autoClose after the enter animation ends.
    // If that animation never finishes, the toast stays until a full refresh.
    newNotificationsDismissTimer = setTimeout(() => {
        toast.dismiss(NEW_NOTIFICATIONS_TOAST_ID);
        newNotificationsDismissTimer = null;
    }, NEW_NOTIFICATIONS_AUTO_CLOSE_MS);
};

export const fetchNotifications = async (store, userUlId, selectedBuyer) => {
    try {
        const queryWithCat = {
            buyerOrganizationULID:
                localStorage.getItem('associatedBroker') === '' ? null : localStorage.getItem('associatedBroker'),
            organizationULID: userUlId,
            limit: 3,
            cursor: 0,
        };

        const { app } = store.getState();
        let countState;
        const queryForNewCount = {
            organizationULID: userUlId,
            timeStamp: app.events.newNotificationList[0]?.created_at,
        };
        await Auth.currentAuthenticatedUser();
        const notifResult = await store.dispatch(getNewNotifications(queryWithCat));
        if (app.events.newNotificationList[0]?.created_at) {
            countState = await store.dispatch(getNewNotificationsCount(queryForNewCount));
        }
        const { meta, payload } = countState || {};
        const notifications = notifResult?.payload?.notifications || [];
        if (meta && meta.requestStatus === 'fulfilled' && payload !== 0) {
            const rowToast = getOpenKnotsToastFromNotificationRecord(notifications[0]);
            if (rowToast) {
                if (!hasRecentOpenKnotsLifecycleToast(rowToast.dedupeKey)) {
                    showOpenKnotsLifecycleToast(rowToast);
                }
            } else {
                showNewNotificationToast(payload, selectedBuyer);
            }
        }
        const newDealFinancing = notifications.find((n) => n.payload && n.payload.event === 'Deal Financing');
        if (newDealFinancing) {
            store.dispatch(setDashboardNeedsRefresh(true));
        }
    } catch {
        // ignore
    }
};

export const maybeStartPolling = (fetchFn, pollInterval) => {
    if (!pollInterval) {
        return setInterval(fetchFn, 30000);
    }
    return pollInterval;
};
